export function normalizeIsoExpiry(isoTimestamp) {
  if (!isoTimestamp || typeof isoTimestamp !== "string") return isoTimestamp;
  return isoTimestamp.replace(/\.(\d{3})\d+Z$/, ".$1Z");
}
